import { getProductCategories } from "inbounds/steps/InboundStepSelectors";
import { createSelector } from "reselect";

export const getShowAssignCategories = createSelector(getProductCategories, (categories) =>
  categories.includes(undefined)
);
